/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2024-07-06
 * @version 2.5.0
 */

// types
import {scenario} from './types';

export const resetValues: scenario.Scenario = {
  hardcoreModeAllowed: null,
  nomadModeAllowed: null,
  category: null,
  groupId: null,
  size: null,
  showCompletionIcon: null,
  requiredScenario: null,
  requiredMilestones: null,
  customSettlementNameAllowed: null,
  loadingScreens: null,
  startingConditions: null,
  visible: null,
  disasters: null,
  milestones: null,
  goals: null,
  events: null,
  locations: null,
};
